import { action, styler } from 'popmotion'

export default {
    props: {
        rootElement: {
            required: false,
            validator: o => o instanceof Element
        },

        delay: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            animation: null,
            waitTimer: null,
            smallWaitTimer: null,
            initAnimation: null
        }
    },

    beforeDestroy() {
        // stop any animtions
        this.stopAnimation()
        this.uninit()
    },

    computed: {
        initAction() {
            return action(({ update, complete }) => {
                update('No init supplied')
                complete()
            })
        },

        animationAction() {
            return action(({ update }) => update('No action supplies'))
        }
    },

    methods: {
        // ---- ---- Controls for delay ---- ----
        async start() {
            await this.init()
            await this.wait()
            // await this.smallWait()
            this.animation = this.animationAction.start(this.animationReaction)
        },

        async init() {
            return new Promise((resolve, reject) => {
                this.initAnimation = this.initAction.start({
                    update: this.initReaction,
                    complete: resolve
                })
            })
        },

        uninit() {
            console.log(
                `${this.$options.name ||
                    this.$options._componentTag} - uninit() is undefined`
            )
        },

        async wait() {
            // resolve if there is no delay
            if (this.delay <= 0) return Promise.resolve()
            //otherwise a promise that will resolve after the delay
            else
                return new Promise(
                    (resolve, _) =>
                        (this.waitTimer = setTimeout(
                            () => resolve(),
                            this.delay
                        ))
                )
        },

        async smallWait() {
            return new Promise(
                (resolve, _) =>
                    (this.smallWaitTimer = setTimeout(() => resolve(), 1000))
            )
        },

        // ---- ---- Controls for animations ---- -----

        initReaction(v) {
            console.log(
                `init reaction for ${this.$options.name ||
                    this.$options._componentTag} - ${v}`
            )
        },

        animationReaction(v) {
            console.log(
                `animation reaction for ${this.$options.name ||
                    this.$options._componentTag} - ${v}`
            )
        },

        stylerGroup(queryString) {
            return Array.from(
                this.rootElement.querySelectorAll(queryString)
            ).map(e => styler(e))
        },

        qa(queryString) {
            return this.stylerGroup(queryString)
        },

        q(qs) {
            return styler(this.rootElement.querySelector(qs))
        },

        stopAnimation() {
            clearTimeout(this.waitTimer)
            clearTimeout(this.smallWaitTimer)

            this.initAnimation &&
                this.initAnimation.stop &&
                this.initAnimation.stop()

            this.animation && this.animation.stop && this.animation.stop()
        }
    },

    render: () => null
}
